module.exports = __webpack_public_path__ + "static/media/4.Welding Cables.67daf039.jpg";